import { Box } from "@material-ui/core";
import { FC, useEffect } from "react";
import { useParams } from "react-router-dom";
import Loader from "../components/Loader";
import { MenuQuestionnaire } from "../pages/pages/property-page-components/EditProperty";
import { fetchA11yStandard } from "../redux/actions/a11yStandardActions";
import { useDispatch, useSelector } from "../redux/store";
import { urls, useRouting } from "../routes";
import { fetchProperty } from "../services/propertyService";
import axios from 'axios';
import Typography from "@mui/material/Typography";
import {getTextByCurrentLanguage} from "../utils/functions";

const QuestionnaireLayout: FC = ({ children }) => {
    const { id } = useParams<{ id: string }>();
    const { routeTo } = useRouting();
    const dispatch = useDispatch();
    const property = useSelector(state => state.propertyReducer.property)!
    const user = useSelector(state => state.authReducer.user)!
    const a11yStandard = useSelector((state) => state.a11yStandardReducer.a11yStandard)
    const loading = useSelector((state) => state.a11yStandardReducer.loading)
    useEffect(() => {
        if (!property && id) {
            dispatch(async (dispatch: any) => {
                return fetchProperty(id, user.token)
                    .then((response) => {
                        dispatch({
                            type: "FETCH_PROPERTY",
                            property: response.data,
                        });
                    }).catch(() => routeTo(urls.notFound))
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    useEffect(() => {
        const source = axios.CancelToken.source();
        if (!a11yStandard.length) {
            // TODO AMS-600 Cancel Request on unmount
            dispatch(fetchA11yStandard(user.token, source.token))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        return () => {
            source.cancel('Canceled');
        }
    }, []);

    return <Box p={12} style={{ height: "100%" }}>
        {/* might need additional checkings when merging A11yUnitsPage & EditFacility */}
        <MenuQuestionnaire title={getTextByCurrentLanguage(property?.name)} />
        {!property || loading ?
            (
                <Loader />
            ) :
            (
                <>
                    {children}
                </>
            )}
    </Box>
}

export default QuestionnaireLayout;